/**
 * Fetch AI-powered consultas joined with their ai_job status.
 * Uses the Supabase client directly (bypasses the mock adapter).
 */
import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "@/lib/supabase";
import type { ConsultaAI } from "../types";

export async function getConsultasAI(client: SupabaseClient = supabase): Promise<ConsultaAI[]> {
  const { data, error } = await client
    .from("consultas")
    .select(
      `
      id,
      user_id,
      label,
      transcript_text,
      analysis_payload,
      ai_job_id,
      created_at,
      ai_jobs ( status, failed_at_stage )
    `,
    )
    .order("created_at", { ascending: false });

  if (error) throw new Error(error.message);

  return (data ?? []).map((row) => {
    const job = Array.isArray(row.ai_jobs) ? row.ai_jobs[0] : row.ai_jobs;
    return {
      id: row.id,
      userId: row.user_id,
      label: row.label,
      transcriptText: row.transcript_text ?? null,
      analysisPayload: (row.analysis_payload as Record<string, unknown>) ?? null,
      aiJobId: row.ai_job_id ?? null,
      createdAt: row.created_at,
      jobStatus: job?.status ?? undefined,
      jobFailedAtStage: job?.failed_at_stage ?? null,
    };
  });
}
